const OPEN_MODAL_LIKE_LISTING = 'OPEN_MODAL_LIKE_LISTING';
const CLOSE_MODAL_LIKE_LISTING = 'CLOSE_MODAL_LIKE_LISTING';

export const action_openModalLikeListing = () => ({
  type: OPEN_MODAL_LIKE_LISTING,
});

export const action_closeModalLikeListing = () => ({
  type: CLOSE_MODAL_LIKE_LISTING,
});

export const reducer_isOpenModalLikeListing = (state = false, { type }) => {
  switch (type) {
    case OPEN_MODAL_LIKE_LISTING:
      return true;
    case CLOSE_MODAL_LIKE_LISTING:
      return false;
    default:
      return state;
  }
};

export const base = 'isOpenModalLikeListing';

export const selector_isOpenModalLikeListing = (state) => state[base];
